export enum InteractionName {
  SQUARE_SDK_LOAD = 'square-sdk-load',
  SQUARE_SDK_INIT = 'square-sdk-init',
  SQUARE_SDK_TOKENIZE = 'square-sdk-tokenize',

  TWO_CHECKOUT_SDK_TOKENIZE = 'two-checkout-sdk-tokenize',

  STRIPE_SDK_TOKENIZE = 'stripe-sdk-tokenize',

  API_TOKENIZE = 'api-tokenize',
  API_VALIDATE = 'api-validate',
  API_GET_PUBLIC_DATA = 'api-get-public-data',
}
